import type { ProductCard } from "@/lib/centra";
import { sendGTMEvent } from "@frend-digital/events/gtm";
import { type MouseEvent, useCallback } from "react";

export const useRecommendationClick = (
	products: (ProductCard | undefined)[] | null | undefined,
	listName: string,
) => {
	return useCallback(
		(e: MouseEvent<HTMLDivElement>) => {
			const card = (e.target as HTMLElement).closest<HTMLElement>(".product-card");
			if (!card || !products) return;
			const productId = card.dataset.productId;
			const product = products.find((p) => p?.depictProductId === productId);
			if (!product) return;
			sendGTMEvent({ ecommerce: null });
			sendGTMEvent({
				event: "select_item",
				ecommerce: {
					item_list_name: listName,
					items: [
						{
							item_id: product.sku,
							item_name: product.name,
							price: product.priceAsNumber,
						},
					],
				},
			});
		},
		[products, listName],
	);
};
